import { render, staticRenderFns } from "./AgendaPrazosTabela.vue?vue&type=template&id=50b8df70&"
import script from "./AgendaPrazosTabela.vue?vue&type=script&lang=js&"
export * from "./AgendaPrazosTabela.vue?vue&type=script&lang=js&"
import style0 from "./AgendaPrazosTabela.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports